import React from 'react';

import { VisitorBlocks } from 'constants-visitor-management';
import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

import { useInviteNameEnabled } from '../hooks/useInviteNameEnabled';
import {
  ContentType,
  VisitorManagementFeatureProperties,
} from 'application-types';

import VisitorManagement from '.';

export default function VisitorBlockHandler({
  propertyKey,
  show,
  value,
  content,
  properties,
  submissionCompletedAt,
  submitAttempted,
  isPreview = false,
  onChange,
  hostInformation,
  uploadedViaBulkImport,
  isInviteNameRequired,
}: {
  propertyKey: string;
  show: boolean;
  value: any;
  content: ContentType;
  properties: VisitorManagementFeatureProperties;
  submissionCompletedAt?: Date;
  submitAttempted?: boolean;
  isPreview?: boolean;
  onChange: (() => null) & ((value: any) => void);
  hostInformation?: { hostTenantId?: string };
  uploadedViaBulkImport?: boolean;
  isInviteNameRequired?: boolean;
}): React.ReactElement | null {
  const visitorNotesEnabled = useFlag(
    FeatureFlag.VisitorManagementVisitorNotes,
    false
  );
  const isInviteNameEnabled = useInviteNameEnabled();

  function renderBlock() {
    switch (propertyKey) {
      case VisitorBlocks.Visitors:
        return VisitorManagement.AddVisitorsBlock({
          onChange,
          properties,
          value,
          show,
          isPreview,
          content,
          submissionCompletedAt,
          submitAttempted,
          hostTenantId: hostInformation?.hostTenantId,
        });
      case VisitorBlocks.Schedule:
        return VisitorManagement.AddScheduleBlock({
          properties,
          onChange,
          content,
          value,
          submissionCompletedAt,
          show,
          isPreview,
        });
      case VisitorBlocks.HostInformation:
        return VisitorManagement.AddHostInformationBlock({
          onChange,
          show,
          properties,
          value,
          content,
          isPreview,
        });
      case VisitorBlocks.Notes:
        return visitorNotesEnabled
          ? VisitorManagement.AddNotesBlock({
              onChange,
              show,
              properties,
              submissionCompletedAt,
              isPreview,
            })
          : null;
      case VisitorBlocks.InviteName:
        return VisitorManagement.AddInviteNameBlock({
          value,
          onChange,
          show: show && isInviteNameEnabled,
          isPreview,
          properties,
          submitAttempted,
          submissionCompletedAt,
          uploadedViaBulkImport,
          isInviteNameRequired,
        });
      default:
        return null;
    }
  }

  return renderBlock();
}
